import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "messageIcon",
  "use": "messageIcon-usage",
  "viewBox": "0 0 16 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 11\" fill=\"none\" id=\"messageIcon\">\n<rect x=\"1.05005\" y=\"1\" width=\"14\" height=\"9.33333\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linejoin=\"round\" />\n<path d=\"M1.05005 1L7.49535 5.29687C7.83125 5.5208 8.26885 5.5208 8.60475 5.29687L15.05 1\" stroke=\"currentColor\" stroke-width=\"1.2\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol